module.exports = __webpack_public_path__ + "img/selectedBg.83a7ff3e.svg";